module.exports = __webpack_public_path__ + "static/media/st.abdc5603.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/st.svg
// module id = 1037
// module chunks = 0